document.addEventListener("DOMContentLoaded", function () {
  var pageWidth = document.documentElement.clientWidth;
  if (pageWidth > 768) {
    xTrans = [];
    anime.set(".box", {
      translateX: function (el, i, l) {
        xTrans[i] = { x: i * 300 };
        return i * 300;
      },
    });
    anime({
      targets: xTrans,
      duration: 100000, // 走一周持续时间
      easing: "linear",
      x: "+=2400", // 将 pageWidth 应用于动画目标
      loop: true,
      update: function (anim) {
        anime.set(".box", {
          translateX: function (el, i, l) {
            return xTrans[i].x % 2400;
          },
        });
      },
    });

    yTrans = [];
    anime.set(".box01", {
      translateX: function (el, j, l) {
        yTrans[j] = { x: j * 300 };
        return j * 300;
      },
    });
    anime({
      targets: yTrans,
      duration: 100000, // 走一周持续时间
      easing: "linear",
      x: "-=2400", // 将 pageWidth 应用于动画目标
      loop: true,
      update: function (anim) {
        anime.set(".box01", {
          translateX: function (el, j, l) {
            b = yTrans[j].x % -2400;
            if (b < -200) {
              return 2400 + b;
            }
            return b;
          },
        });
      },
    });
  } else {
    xTrans = [];
    anime.set(".box", {
      translateX: function (el, i, l) {
        xTrans[i] = { x: i * 170 };
        return i * 170;
      },
    });
    anime({
      targets: xTrans,
      duration: 100000, // 走一周持续时间
      easing: "linear",
      x: "+=1360", // 将 pageWidth 应用于动画目标
      loop: true,
      update: function (anim) {
        anime.set(".box", {
          translateX: function (el, i, l) {
            return xTrans[i].x % 1360;
          },
        });
      },
    });
    yTrans = [];
    anime.set(".box01", {
      translateX: function (el, j, l) {
        yTrans[j] = { x: j * 170 };
        return j * 170;
      },
    });
    anime({
      targets: yTrans,
      duration: 100000, // 走一周持续时间
      easing: "linear",
      x: "-=1360", // 将 pageWidth 应用于动画目标
      loop: true,
      update: function (anim) {
        anime.set(".box01", {
          translateX: function (el, j, l) {
            b = yTrans[j].x % -1360;
            if (b < -170) {
              return 1360 + b;
            }
            return b;
          },
        });
      },
    });
  }
});
